/**
 * Entry point applicazione client.
 *
 * Carica i template compilati e registra i Custom Elements.
 * Viene bundlato da scripts/build-app.ts → web/public/js/app.js (IIFE).
 */
import appTemplates from './generated/templates.ts';
import { setTemplates } from './lib/template-parse.ts';
import { enforcePerm } from './lib/perm.ts';
import { initModalAriaFix } from './lib/modal-fix-aria.ts';

import { RicercaLavoratori } from './components/ricerca-lavoratori.ts';
import { RicercaImprese } from './components/ricerca-imprese.ts';
import { DettaglioLavoratore } from './components/dettaglio-lavoratore.ts';
import { DettaglioImpresa } from './components/dettaglio-impresa.ts';
import { PasskeyLogin } from './components/passkey-login.ts';
import { GestionePasskey } from './components/gestione-passkey.ts';
import { CambioPassword } from './components/cambio-password.ts';
import { EditDelega } from './components/edit-delega.ts';
import { ListaDeleghe } from './components/lista-deleghe.ts';
import { DataTable } from './components/data-table.ts';
import { ListaPresentazioni } from './components/lista-presentazioni.ts';
import { DettaglioPresentazione } from './components/dettaglio-presentazione.ts';
import { TabellaDisdette } from './components/tabella-disdette.ts';
import { NuovaDisdetta } from './components/nuova-disdetta.ts';
import { Elaborazioni } from './components/elaborazioni.ts';
import { Allineamento } from './components/allineamento.ts';
import { GestioneUtenti } from './components/gestione-utenti.ts';
import { TabellaLavoratori } from './components/tabella-lavoratori.ts';
import { TabellaImprese } from './components/tabella-imprese.ts';
import { ElencoDeleghe } from './components/elenco-deleghe.ts';
import { TemaSelector } from './components/tema-selector.ts';
import { OperatoreCombobox } from './components/operatore-combobox.ts';
import { EditLavoratore } from './components/edit-lavoratore.ts';
import { EditImpresa } from './components/edit-impresa.ts';
import { ImpresaPicker } from './components/impresa-picker.ts';
import { LavoratorePicker } from './components/lavoratore-picker.ts';
import { CategoriaSelect } from './components/categoria-select.ts';
import { IscrizioneAltriSettoriForm } from './components/iscrizione-altri-settori-form.ts';
import { IscrizioniAltriSettoriLista } from './components/iscrizioni-altri-settori-lista.ts';
import { StatiniInvio } from './components/statini-invio.ts';
import { StatiniInviati } from './components/statini-inviati.ts';
import { Archivio } from './components/archivio.ts';
import { ConfrontoSetup } from './components/confronto-setup.ts';
import { GraficoStatistiche } from './components/grafico-statistiche.ts';
import { StatisticheSetup } from './components/statistiche-setup.ts';
import { AndamentoGruppo } from './components/andamento-gruppo.ts';
import { TabellaConfronto } from './components/tabella-confronto.ts';
import { BackupManager } from './components/backup-manager.ts';
import { BergamoCeUpload } from './components/casse/bergamo/bergamo-ce-upload.ts';
import { BergamoEcUpload } from './components/casse/bergamo/bergamo-ec-upload.ts';
import { CassaUpload } from './components/cassa-upload.ts';

// --- Init template engine client ---
setTemplates(appTemplates);
initModalAriaFix();

// --- Registrazione componenti ---
RicercaLavoratori.register();
RicercaImprese.register();
DettaglioLavoratore.register();
DettaglioImpresa.register();
PasskeyLogin.register();
GestionePasskey.register();
CambioPassword.register();
EditDelega.register();
DataTable.register();
ListaDeleghe.register();
ListaPresentazioni.register();
DettaglioPresentazione.register();
TabellaDisdette.register();
NuovaDisdetta.register();
Elaborazioni.register();
Allineamento.register();
GestioneUtenti.register();
TabellaLavoratori.register();
TabellaImprese.register();
ElencoDeleghe.register();
TemaSelector.register();
OperatoreCombobox.register();
EditLavoratore.register();
EditImpresa.register();
ImpresaPicker.register();
LavoratorePicker.register();
CategoriaSelect.register();
IscrizioneAltriSettoriForm.register();
IscrizioniAltriSettoriLista.register();
StatiniInvio.register();
StatiniInviati.register();
Archivio.register();
ConfrontoSetup.register();
GraficoStatistiche.register();
StatisticheSetup.register();
AndamentoGruppo.register();
TabellaConfronto.register();
BackupManager.register();
// Custom upload casse: registrare i custom PRIMA di wc-cassa-upload, cosi'
// al primo mount del generico `customElements.get(...)` ritorna gia' la classe.
BergamoCeUpload.register();
BergamoEcUpload.register();
CassaUpload.register();

// --- Enforce permessi su markup server-rendered ---
document.addEventListener('DOMContentLoaded', () => enforcePerm());

// --- Switch territorio (dropdown navbar) ---
document.addEventListener('click', async (e) => {
  const btn = (e.target as HTMLElement).closest('[data-action="switch-org"]') as HTMLElement | null;
  if (!btn) return;
  const orgId = btn.dataset.orgId;
  if (!orgId) return;
  const res = await fetch(`/auth/switch-org/${orgId}`, { method: 'POST', credentials: 'same-origin' });
  if (res.ok) {
    window.location.href = '/';
  } else {
    Weext.toast('Impossibile cambiare territorio', { type: 'danger' });
  }
});
